import { QUICK_RANGES } from './common';
import { TIME_UNITS } from './date';

export const PATTERN_TYPES = {
  alarm: 'alarm',
  entity: 'entity',
  pbehavior: 'pbehavior',
  serviceWeather: 'weather_service',
};

export const PATTERN_OPERATORS = {
  equal: 'equal',
  contains: 'contains',
  notEqual: 'not_equal',
  notContains: 'not_contains',

  beginWith: 'begin_with',
  notBeginWith: 'not_begin_with',
  endsWith: 'ends_with',
  notEndWith: 'not_end_with',

  exist: 'exist',
  notExist: 'not_exist',

  hasEvery: 'has_every',
  hasOneOf: 'has_one_of',
  isOneOf: 'is_one_of',
  hasNot: 'has_not',
  isNotOneOf: 'is_not_one_of',
  isEmpty: 'is_empty',
  isNotEmpty: 'is_not_empty',

  higher: 'higher_than',
  lower: 'lower_than',

  longer: 'longer',
  shorter: 'shorter',

  ticketAssociated: 'ticket_associated',
  ticketNotAssociated: 'ticket_not_associated',

  canceled: 'canceled',
  notCanceled: 'not_canceled',

  snoozed: 'snoozed',
  notSnoozed: 'not_snoozed',

  acked: 'acked',
  notAcked: 'not_acked',

  isGrey: 'is_grey',
  isNotGrey: 'is_not_grey',

  with: 'with',
  without: 'without',

  withLabel: 'with_label',
  withoutLabel: 'without_label',

  activated: 'activated',
  inactive: 'inactive',

  enabled: 'enabled',
  disabled: 'disabled',

  isMetaAlarm: 'is_meta_alarm',
  isNotMetaAlarm: 'is_not_meta_alarm',
  ruleIs: 'rule_is',

  regexp: 'regexp',

  within: 'within',
  olderThan: 'older_than',
  inRangeDates: 'in_range_dates',
  inRangePeriod: 'in_range_period',
};

export const PATTERN_CONDITIONS = {
  equal: 'eq',
  notEqual: 'neq',
  greater: 'gt',
  less: 'lt',
  regexp: 'regexp',
  hasEvery: 'has_every',
  isOneOf: 'is_one_of',
  hasOneOf: 'has_one_of',
  hasNot: 'has_not',
  isNotOneOf: 'is_not_one_of',
  isEmpty: 'is_empty',
  exist: 'exist',
  relativeTime: 'relative_time',
  absoluteTime: 'absolute_time',
  contains: 'contain',
  notContains: 'not_contain',
  beginWith: 'begin_with',
  notBeginWith: 'not_begin_with',
  endsWith: 'end_with',
  notEndWith: 'not_end_with',
  hasLabels: 'has_labels',
  hasNotLabels: 'has_not_labels',
};

export const PATTERN_FIELD_TYPES = {
  string: 'string',
  number: 'int',
  boolean: 'bool',
  null: 'null',
  stringArray: 'string_array',
  timestamp: 'timestamp',
};

export const PATTERN_DATE_OPERATORS = [
  PATTERN_OPERATORS.within,
  PATTERN_OPERATORS.olderThan,
  PATTERN_OPERATORS.inRangePeriod,
  PATTERN_OPERATORS.inRangeDates,
];

export const DEFAULT_PATTERN_FIELD_TYPES = [
  { value: PATTERN_FIELD_TYPES.string },
  { value: PATTERN_FIELD_TYPES.number },
  { value: PATTERN_FIELD_TYPES.boolean },
  { value: PATTERN_FIELD_TYPES.stringArray },
];

export const ENTITY_PATTERN_FIELD_TYPES = [
  ...DEFAULT_PATTERN_FIELD_TYPES,
  { value: PATTERN_FIELD_TYPES.timestamp },
];

export const PATTERN_OPERATORS_WITHOUT_VALUE = [
  PATTERN_OPERATORS.exist,
  PATTERN_OPERATORS.notExist,
  PATTERN_OPERATORS.isEmpty,
  PATTERN_OPERATORS.isNotEmpty,
  PATTERN_OPERATORS.ticketAssociated,
  PATTERN_OPERATORS.ticketNotAssociated,
  PATTERN_OPERATORS.acked,
  PATTERN_OPERATORS.notAcked,
  PATTERN_OPERATORS.snoozed,
  PATTERN_OPERATORS.notSnoozed,
  PATTERN_OPERATORS.canceled,
  PATTERN_OPERATORS.notCanceled,
  PATTERN_OPERATORS.isNotGrey,
  PATTERN_OPERATORS.isGrey,
  PATTERN_OPERATORS.activated,
  PATTERN_OPERATORS.inactive,
  PATTERN_OPERATORS.enabled,
  PATTERN_OPERATORS.disabled,
  PATTERN_OPERATORS.isMetaAlarm,
  PATTERN_OPERATORS.isNotMetaAlarm,
];

export const PATTERN_RULE_TYPES = {
  infos: 'infos',
  extraInfos: 'extraInfos',
  date: 'date',
  duration: 'duration',
  string: 'string',
  number: 'number',
  object: 'object',
};

export const PATTERN_RULE_INFOS_FIELDS = {
  value: 'value',
  name: 'name',
};

export const PATTERN_ARRAY_OPERATORS = [
  PATTERN_OPERATORS.hasEvery,
  PATTERN_OPERATORS.hasOneOf,
  PATTERN_OPERATORS.isOneOf,
  PATTERN_OPERATORS.hasNot,
  PATTERN_OPERATORS.isNotOneOf,
  PATTERN_OPERATORS.isEmpty,
  PATTERN_OPERATORS.isNotEmpty,
  PATTERN_OPERATORS.with,
  PATTERN_OPERATORS.without,
  PATTERN_OPERATORS.withLabel,
  PATTERN_OPERATORS.withoutLabel,
];

export const PATTERN_DURATION_OPERATORS = [
  PATTERN_OPERATORS.longer,
  PATTERN_OPERATORS.shorter,
];

export const PATTERN_NUMBER_OPERATORS = [
  PATTERN_OPERATORS.equal,
  PATTERN_OPERATORS.notEqual,
  PATTERN_OPERATORS.higher,
  PATTERN_OPERATORS.lower,
];

export const PATTERN_STRING_OPERATORS = [
  PATTERN_OPERATORS.equal,
  PATTERN_OPERATORS.notEqual,
  PATTERN_OPERATORS.contains,
  PATTERN_OPERATORS.notContains,
  PATTERN_OPERATORS.beginWith,
  PATTERN_OPERATORS.notBeginWith,
  PATTERN_OPERATORS.endsWith,
  PATTERN_OPERATORS.notEndWith,
  PATTERN_OPERATORS.regexp,
];

export const PATTERN_BOOLEAN_OPERATORS = [
  PATTERN_OPERATORS.equal,
  PATTERN_OPERATORS.notEqual,
];

export const PATTERN_NULL_OPERATORS = [
  PATTERN_OPERATORS.equal,
  PATTERN_OPERATORS.notEqual,
];

export const PATTERN_EXISTS_OPERATORS = [
  PATTERN_OPERATORS.exist,
  PATTERN_OPERATORS.notExist,
];

export const PATTERN_ALARM_TAG_LABEL_OPERATORS = [
  PATTERN_OPERATORS.withLabel,
  PATTERN_OPERATORS.withoutLabel,
];

export const PATTERN_QUICK_RANGES_WITHOUT_CUSTOM = [
  QUICK_RANGES.last15Minutes,
  QUICK_RANGES.last30Minutes,
  QUICK_RANGES.last1Hour,
  QUICK_RANGES.last3Hour,
  QUICK_RANGES.last6Hour,
  QUICK_RANGES.last12Hour,
  QUICK_RANGES.last24Hour,
  QUICK_RANGES.last2Days,
  QUICK_RANGES.last7Days,
  QUICK_RANGES.last30Days,
];

export const PATTERN_QUICK_RANGES_DURATIONS = {
  [QUICK_RANGES.last15Minutes.value]: { value: 15, unit: TIME_UNITS.minute },
  [QUICK_RANGES.last30Minutes.value]: { value: 30, unit: TIME_UNITS.minute },
  [QUICK_RANGES.last1Hour.value]: { value: 1, unit: TIME_UNITS.hour },
  [QUICK_RANGES.last3Hour.value]: { value: 3, unit: TIME_UNITS.hour },
  [QUICK_RANGES.last6Hour.value]: { value: 6, unit: TIME_UNITS.hour },
  [QUICK_RANGES.last12Hour.value]: { value: 12, unit: TIME_UNITS.hour },
  [QUICK_RANGES.last24Hour.value]: { value: 24, unit: TIME_UNITS.hour },
  [QUICK_RANGES.last2Days.value]: { value: 2, unit: TIME_UNITS.day },
  [QUICK_RANGES.last7Days.value]: { value: 7, unit: TIME_UNITS.day },
  [QUICK_RANGES.last30Days.value]: { value: 30, unit: TIME_UNITS.day },
};

export const PATTERN_QUICK_RANGES = [
  ...PATTERN_QUICK_RANGES_WITHOUT_CUSTOM,
  QUICK_RANGES.custom,
];

export const PATTERN_CUSTOM_ITEM_VALUE = Symbol('custom');

export const PATTERN_TABS = {
  patterns: 'patterns',
  corporatePatterns: 'corporatePatterns',
};

export const PATTERN_EDITOR_TABS = {
  simple: 'simple',
  advanced: 'advanced',
};

export const PATTERNS_FIELDS = {
  alarm: 'alarm_pattern',
  entity: 'entity_pattern',
  pbehavior: 'pbehavior_pattern',
  event: 'event_pattern',
  totalEntity: 'total_entity_pattern',
  serviceWeather: 'weather_service_pattern',
};

export const PATTERN_TYPES_TO_PATTERNS_FIELDS = {
  [PATTERN_TYPES.alarm]: PATTERNS_FIELDS.alarm,
  [PATTERN_TYPES.entity]: PATTERNS_FIELDS.entity,
  [PATTERN_TYPES.pbehavior]: PATTERNS_FIELDS.pbehavior,
  [PATTERN_TYPES.serviceWeather]: PATTERNS_FIELDS.serviceWeather,
};

export const PATTERN_OPTIMIZATION_STATUSES = {
  created: 0,
  running: 1,
  success: 2,
  failed: 3,
};
